import { ActionType, TokenType } from '../utils/constants';

export enum TOTPStep {
  QR_SETUP = 'qr-setup',
  VERIFY_CODE = 'verify-code',
  SUCCESS = 'success',
}

export enum VerificationMethod {
  TOTP = 'TOTP',
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  BACKUP = 'BACKUP',
}

export enum MfaType {
  SMS = 'SMS',
  SMS_AND_EMAIL = 'SMS_AND_EMAIL',
  EMAIL = 'EMAIL',
  AUTH_APP = 'AUTH_APP',
}

export enum TotpAction {
  ACTIVATE = 'ACTIVATE',
  DEACTIVATE = 'DEACTIVATE',
}

export enum TotpStatus {
  PENDING = 'PENDING',
  ACTIVATED = 'ACTIVATED',
  DEACTIVATED = 'DEACTIVATED',
  NONE = 'NONE',
}

export interface InitTOTPResDto {
  secret: string;
  qrCodeUri: string;
  qrCodeB64: string;
}

export interface CodeVerifyOptions {
  actionType?: ActionType;
  tokenType?: TokenType;
  isBackupCode?: boolean;
}
